import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import {
  RDS_DATE_FORMATS,
  RdsButtonComponent,
  RdsDateFormats,
  RdsDatepickerComponent,
  RdsDatepickerInputDirective,
  RdsDatepickerToggleComponent,
  RdsFormFieldComponent,
  RdsInputDirective,
  RdsSelectComponent,
  RdsSingleSelectOptionComponent,
} from '@rds/angular-components';
import { EMPTY, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';

import { ChartSearchParams, ViewportService } from '@bookly/shared';

import { ChartFiltersService } from '../../services/chart-filters.service';

const CUSTOM_DATE_FORMATS: RdsDateFormats = {
  parse: {
    dateInput: null,
  },
  display: {
    dateInput: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bsh-char-filter',
  templateUrl: './chart-filter.component.html',
  styleUrl: './chart-filter.component.scss',
  imports: [
    RdsDatepickerInputDirective,
    RdsDatepickerToggleComponent,
    RdsDatepickerComponent,
    ReactiveFormsModule,
    RdsFormFieldComponent,
    RdsInputDirective,
    RdsSelectComponent,
    RdsSingleSelectOptionComponent,
    RdsButtonComponent,
  ],
  providers: [
    {
      provide: RDS_DATE_FORMATS,
      useValue: CUSTOM_DATE_FORMATS,
    },
  ],
})
export class ChartFilterComponent implements OnInit {
  readonly #viewport = inject(ViewportService);
  readonly #filtersFormService = inject(ChartFiltersService);
  readonly filtersForm = this.#filtersFormService.filtersForm;
  readonly #destroyRef = inject(DestroyRef);
  protected readonly isMobileScreen = this.#viewport.isMobile;
  protected readonly months = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' },
  ];

  @Output() filters = new EventEmitter<ChartSearchParams>();

  ngOnInit() {
    this.#viewport.isMobile$
      .pipe(
        switchMap(isMobile =>
          isMobile ? EMPTY : this.filtersForm.valueChanges
        ),
        distinctUntilChanged(),
        debounceTime(1000),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(() => this.applyFilters());
  }

  protected applyFilters() {
    this.filters.emit(this.#filtersFormService.getSelectedFormData());
  }

  protected resetForm() {
    this.#filtersFormService.resetForm();
  }
}
